import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {CategoriesTable} from '../_tables/categories.table';
import {Options} from 'select2';
import {Select2OptionData} from 'ng-select2';
import {UploadFileService} from '../_services/upload-file.service';
import {TopManagementService} from '../_services/top-management.service';
import {TopMFilesModel} from '../_models/topMFiles.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';

@Component({
    selector: 'app-create-tm',
    templateUrl: './create-tm.component.html',
    styleUrls: ['./create-tm.component.scss'],
    providers: [CategoriesTable]
})


export class CreateTmComponent implements OnInit {

    constructor(private categoriesTable: CategoriesTable,
                private uploadFile: UploadFileService,
                private topMService: TopManagementService,
                private snackBar: MatSnackBar,
                private router: Router) {
    }

    formResponse: boolean;
    formSent: boolean;

    // Select 2 Options
    public multiOptions: Options;

    // Form
    topManagementFormData: object;
    topMCategoriesData: Array<Select2OptionData> = []
    defaultStatus = 'draft'

    // Upload File
    selectedFile: any;
    selectedFileArray = [];

    // Repeater
    topDTO: any = [];
    repeaterData: {
        files: TopMFilesModel[];
    }

    ngOnInit() {

        this.topMCategoriesData = this.categoriesTable.topManagementCategories;


        // Select 2 Options
        this.multiOptions = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            multiple: true,
            allowClear: true
        };

        this.repeaterData = {
            files: []
        }

        this.addFile()
    }

    selectFile(e) {
        this.selectedFile = e.target.files;
        this.selectedFileArray.push(this.selectedFile);
    }

    createTopM(form: NgForm) {

        // Repeater Object
        this.topDTO = {
            files: form.value.files
        }

        // Files Repeater
        const filesValue = [];
        for (const fileElement of Object.keys(this.topDTO.files)) {
            const file = this.topDTO.files[fileElement];
            filesValue.push(file);
        }

        this.topManagementFormData = {
            title: form.value.title,
            categories: form.value.topManagerCategories,
            description: form.value.description,
            status: form.value.status,
            userConsent: []
        }

        if (form.valid) {

            this.topMService.createTopManagement(this.topManagementFormData).subscribe((responseData: any) => {
                this.formResponse = true;
                this.formSent = true;
                // Upload Service for Upload File
                for (const fileData of this.selectedFileArray) {
                    this.uploadFile.upload(fileData, '/crm/uploadTopManagementFile?topManagementId=' + responseData.reason);
                }
                setTimeout(() => {
                    this.router.navigate(['/sistemerp/top-management/postare/' + responseData.reason])
                }, 4000);
            }, error => {
                this.formResponse = false;
                this.formSent = true;
            })
        } else {
            this.formResponse = false;
            this.formSent = true;
        }
    }

    // Product Repeater -- Start
    addFile() {
        this.repeaterData.files.push({
            link: ''
        });
    }

    removeFile(index: number) {
        this.repeaterData.files.splice(index, 1);
        this.selectedFileArray.splice(index, 1);
    }

    // Product Repeater -- END
}
